import type {
  TestHotspotFeedbackSchemaType,
  TestHotspotSchemaType,
} from '@vedalib/editor/lib/brand'
import styled, { css } from 'styled-components'

import { hover } from 'services/Branding/common.styled'
import type { ElementFeedbackCss, ElementStyleCss } from 'services/Branding/types'

const correct = ($feedback: ElementFeedbackCss<TestHotspotFeedbackSchemaType>) => css`
  background-color: ${$feedback.correct.backgroundColor};
  background-image: ${$feedback.correct.backgroundImage};
`

const incorrect = ($feedback: ElementFeedbackCss<TestHotspotFeedbackSchemaType>) => css`
  background-color: ${$feedback.incorrect.backgroundColor};
  background-image: ${$feedback.incorrect.backgroundImage};
`

const spot = ($styles: ElementStyleCss<TestHotspotSchemaType>) => css`
  background-color: ${$styles.spot.backgroundColor};
  background-image: ${$styles.spot.backgroundImage};
`

const SpotStyled = styled.div<{
  $feedback: ElementFeedbackCss<TestHotspotFeedbackSchemaType>
  $styles: ElementStyleCss<TestHotspotSchemaType>
  $result: unknown
  $isTrue: boolean
  $showFeedbackIcon?: boolean
}>`
  transition: 0.2s;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  font-size: 24px;
  transform: translate(-50%, -50%);
  z-index: 10;
  overflow: hidden;

  width: ${({ $styles }) => $styles.spot.width};
  height: ${({ $styles }) => $styles.spot.height};
  color: ${({ $styles }) => $styles.spot.color};

  ${({ $isTrue, $styles, $feedback, $showFeedbackIcon }) =>
    $showFeedbackIcon ? ($isTrue ? correct($feedback) : incorrect($feedback)) : spot($styles)}

  ${hover}
`

export default SpotStyled
